import React from 'react';

export const EyeIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="17"
            height="11"
            viewBox="0 0 17 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5.833c-1.949 0-3.717.849-5.08 1.786A15.598 15.598 0 00.665 5.061l-.002.002a.667.667 0 000 .874l.002.002A15.597 15.597 0 003.419 8.38c1.364.937 3.132 1.786 5.081 1.786 1.949 0 3.717-.849 5.08-1.786a15.6 15.6 0 002.754-2.442l.002-.002a.666.666 0 000-.874l-.252.218.25-.22a15.601 15.601 0 00-2.753-2.442C12.217 1.682 10.449.833 8.5.833zm4.703 2.336a14.932 14.932 0 012.63 2.33 14.932 14.932 0 01-2.63 2.332C11.895 8.731 10.259 9.5 8.5 9.5c-1.76 0-3.395-.77-4.703-1.669A14.934 14.934 0 011.167 5.5a14.933 14.933 0 012.63-2.331c1.308-.9 2.944-1.67 4.703-1.67 1.76 0 3.395.77 4.703 1.67zM6.344 6.393a2.333 2.333 0 114.312-1.786 2.333 2.333 0 01-4.312 1.786z"
                fill="currentColor"
            />
        </svg>
    );
};
